import styled from "@emotion/styled"
import React, { useContext } from "react"
import tw from "twin.macro"
import tailwindConfig from "../utils/tailwindConfig"
import { PageContext } from "./PageProvider"

const StyledButton = styled.button`
  ${tw`lg:hidden`}
  height: 24px;
  display: inline-block;
  cursor: pointer;
  transition-property: opacity, filter;
  transition-duration: 0.15s;
  transition-timing-function: linear;
  font: inherit;
  color: inherit;
  text-transform: none;
  background-color: transparent;
  border: 0;
  margin: 0;
  overflow: visible;

  .box {
    width: 40px;
    height: 24px;
    display: inline-block;
    position: relative;
  }

  .inner {
    display: block;
    top: 50%;
    margin-top: -2px;
    transition-duration: 0.22s;
    transition-timing-function: cubic-bezier(0.55, 0.055, 0.675, 0.19);
    &,
    &::before,
    &::after {
      width: 40px;
      height: 4px;
      background-color: ${tailwindConfig.theme.colors.blue.DEFAULT};
      border-radius: 4px;
      position: absolute;
      transition-property: transform;
      transition-duration: 0.15s;
      transition-timing-function: ease;
    }
    &::before,
    &::after {
      content: "";
      display: block;
    }
    &::before {
      top: -10px;
      transition: top 0.1s 0.25s ease-in, opacity 0.1s ease-in;
    }
    &::after {
      bottom: -10px;
      transition: bottom 0.1s 0.25s ease-in,
        transform 0.22s cubic-bezier(0.55, 0.055, 0.675, 0.19);
    }
  }
`

const MobileMenuButton = () => {
  const { menuIsOpen, toggleMenu } = useContext(PageContext)

  return (
    <StyledButton
      type="button"
      aria-label="Menu"
      aria-controls="mobile-menu"
      aria-expanded={menuIsOpen ? true : false}
      id="mobile-menu-button"
      onClick={toggleMenu}
    >
      <span className="box" aria-hidden="true">
        <span className="inner"></span>
      </span>
    </StyledButton>
  )
}

export default MobileMenuButton
